export default {
  'whyus.eyebrow': 'Why Choose Us',
  'whyus.heroTitleA': 'Why travelers choose',
  'whyus.home': 'Home',
  'whyus.whyUs': 'Why Us',
  'whyus.commitmentsNote': 'These are not marketing claims. They are operational standards we hold ourselves to — and you can hold us accountable for.',
  'whyus.companyInfo': 'Company Information',
  'whyus.name': 'Name',
  'whyus.license': 'License',
  'whyus.address': 'Address',
  'whyus.phone': 'Phone',
  'whyus.email': 'Email',
  'whyus.ourOffices': 'Our Offices',
  'whyus.ourCoverage': 'Our Coverage',
  'whyus.travelersFrom': 'Travelers From',
  'whyus.accountName': 'Account Name:',
  'whyus.bank': 'Bank:',
  'whyus.account': 'Account:',
  'whyus.swift': 'SWIFT:',
  'whyus.videoTestimonial': 'Video testimonial',
  'whyus.clickToClose': 'Click to close',
  'whyus.heroAlt': 'Why choose Vietnam Travel',
  'whyus.finalCtaAlt': 'Vietnam landscape',
  'whyus.mapTitle': 'Vietnam Map',
};